import {useFetcher} from '@remix-run/react/dist/components';
import {
  CartLine,
  CartLineUpdateInput,
} from '@shopify/hydrogen/storefront-api-types';
import React from 'react';
import * as Icon from 'react-feather';
import {CartAction} from '~/lib/type';

function UpdateCartButton({
  children,
  lines,
}: {
  children: React.ReactNode;
  lines: CartLineUpdateInput[];
}) {
  const fetcher = useFetcher();

  return (
    <fetcher.Form action="/cart" method="post">
      <input type="hidden" name="cartAction" value={CartAction.UPDATE_CART} />
      <input type="hidden" name="lines" value={JSON.stringify(lines)} />
      {children}
    </fetcher.Form>
  );
}
const QtyForm = ({line}: {line: CartLine}) => {
  if (!line || typeof line?.quantity === 'undefined') return null;
  const {id: lineId, quantity} = line;
  const prevQuantity = Number(Math.max(0, quantity - 1).toFixed(0));
  const nextQuantity = Number((quantity + 1).toFixed(0));

  return (
    <>
      <div className="input-counter">
        <div className="diplay-flex items-center border rounded">
          <UpdateCartButton lines={[{id: lineId, quantity: prevQuantity}]}>
            <button
              name="decrease-quantity"
              aria-label="Decrease quantity"
              className="w-10 h-10 transition text-primary/50 hover:text-primary disabled:text-primary/10"
              value={prevQuantity}
              disabled={quantity <= 1}
            >
              <div>&#8722;</div>
            </button>
          </UpdateCartButton>

          <div
            className="px-2 text-center item-quantity"
            data-test="item-quantity"
          >
            {quantity}
          </div>

          <UpdateCartButton lines={[{id: lineId, quantity: nextQuantity}]}>
            <button
              className="w-10 h-10 transition text-primary/50 hover:text-primary"
              name="increase-quantity"
              value={nextQuantity}
              aria-label="Increase quantity"
            >
              <div>&#43;</div>
            </button>
          </UpdateCartButton>
        </div>
      </div>
    </>
  );
};

export default QtyForm;
